
import { map, each, isNumber } from 'lodash';
import { link } from 'fs';

function formatField(field: any) {
  if(!field.input) {
    field.input = 'text';
  }
  else if(field.input === 'list') {
    field.valuesList = [];

    each(field.values, (value, key: any) => {
      let valueItem: any = {};

      let id, text;

      // The id can be the value itself in case of a array
      // or the key in case of a key/value map object
      if(isNumber(key)) {
        id = value;
      }
      else {
        id = key;
      }

      if(id === value) {
        text = value;
      }
      else {
        text = `${value} (${id})`;
      }

      field.valuesList.push({
        id,
        text
      });
    });
  }
}

export interface Target {
  id: string
  text: string
  link: any
}

export class DossierModel {
  data: any;

  constructor(data: string) {
    this.data = JSON.parse(data);

    // Add missing properties in the model
    each(this.data, (link: any, linkId: string) => {
      each(link.fields, formatField);

      each(link.types, (type: any, typeId: string) => {
        each(type, formatField);
      });
    });
  }

  get targets(): Target[] {
    return map(this.data, (link: any, key: string) => {
      return {
        id: key,
        text: link.label,
        link
      };
    });
  }

  getTargetLabel(targetId: string) {
    return this.data[targetId].label;
  }
}